export default "__VITE_ASSET__CWkAP3F2__"